// From https://github.com/zeit/next.js/blob/master/examples/with-sentry/utils/sentry.js
// User details are not passed on
// NOTE: This require will be replaced with `@sentry/browser` when
// process.browser === true thanks to the webpack config in next.config.js
const Sentry = require('@sentry/node');

let dsn = 'https://bcd575ef762947bbb956d7d5a89be716@sentry.io/1319455';
if (process.browser) {
    dsn = 'https://37d81a749ea747b39140b1f038b6d8cc@sentry.io/1318577';
}

const sentryOptions = {
    dsn: dsn,
    environment: process.env.APPLICATION_ENV,
    release: process.env.BUILD_ID,
    maxBreadcrumbs: 10
};

Sentry.init(sentryOptions);

module.exports = {

    Sentry: Sentry,

    captureException: (err, { req, res, errorInfo, query, pathname }) => {
        Sentry.configureScope((scope) => {
            if (err.message) {
                // De-duplication currently doesn't work correctly for SSR / browser errors
                // so we force deduplication by error message if it is present
                scope.setFingerprint([err.message])
            }

            if (err.statusCode) {
                scope.setExtra('statusCode', err.statusCode)
            }

            if (res && res.statusCode) {
                scope.setExtra('statusCode', res.statusCode)
            }

            if (process.browser) {
                scope.setTag('ssr', false);
                scope.setExtra('query', query);
                scope.setExtra('pathname', pathname);
            }
            else {
                scope.setTag('ssr', true);
                if (req) {
                    scope.setExtra('url', req.originalUrl);
                    scope.setExtra('method', req.method);
                    scope.setExtra('headers', req.headers);
                    scope.setExtra('params', req.params);
                    scope.setExtra('query', req.query);
                }
            }

            if (errorInfo) {
                Object.keys(errorInfo).forEach(key => scope.setExtra(key, errorInfo[key]));
            }
        });

        return Sentry.captureException(err);
    }
};

